<template>
  <dashboard-section v-if="projects.length">
    <template #title>
      <h2
        class="text-xl pr-6 mr-6"
        :class="{ 'border-r': projects.length === 3 }"
      >
        My Projects
      </h2>
      <icon-link
        v-if="projects.length === 3"
        class="font-normal"
        :href="route('projects.index')"
        icon="cheveron-right-circle"
        icon-placement="right"
      >
        Projects archive
      </icon-link>
    </template>
    <ul class="list-reset flex flex-wrap -mx-4">
      <li
        v-for="project in projects"
        :key="project.uuid"
        class="w-full lg:w-1/3 lg:flex p-4"
      >
        <user-project-card :project="project" :user="state.user" />
      </li>
      <li
        v-for="filler in [1, 2, 3].slice(projects.length, 3)"
        :key="filler"
        class="hidden lg:w-1/3 lg:flex p-4"
        style="min-height: 13rem"
      >
        <div class="w-full border-dashed border border-grey-300" />
      </li>
    </ul>
  </dashboard-section>
</template>

<script>
export default {
  name: "DashboardProjects",
  props: {
    projects: {
      type: Array,
      default: () => []
    },
    state: {
      type: Object,
      required: true
    }
  }
};
</script>
